import { MyGuestQuizReport, MyHostQuizReport } from './../../../interfaces/quiz';
export abstract class SelectQuizReport {
  
  isContentLoading = true;
  abstract title: string;
  abstract selectedQuizReport: MyHostQuizReport | MyGuestQuizReport | undefined;
  
  onSelectedQuizReport(data: MyHostQuizReport | MyGuestQuizReport | undefined): void { }
  onDestroy(): void { }
  abstract setInitialState(): void;
}

export class SelectHostQuizReport extends SelectQuizReport {

  title = '성격 유형 퀴즈 선택';
  selectedQuizReport: MyHostQuizReport | undefined;

  constructor() {
    super();
  }

  setInitialState(): void {
    this.isContentLoading = false;
  }
}

export class SelectGuestQuizReport extends SelectQuizReport {

  title = '응답 기록 선택';
  selectedQuizReport: MyGuestQuizReport | undefined;

  constructor() {
    super();
  }
  
  setInitialState(): void {
    this.isContentLoading = false;
  }
}